module.exports = __webpack_public_path__ + "img/KurdoShaban-daxwenmawa.19538a0a.jpg";